import type { Notification } from "../types/notification.types.ts"

const CLICKABLE_TARGET_TYPES = ["project", "lead"] as const

export function isNotificationClickable(notification: Notification): boolean {
  const type = notification?.target?.type
  return !!type && (CLICKABLE_TARGET_TYPES as readonly string[]).includes(type)
}
